<ef-loading-container loadingText="Connecting..."></ef-loading-container>
<p>
    {{ message }}
</p>
